export default __webpack_public_path__ + "static/media/mb-cta-book.e6c16217.svg";